import(/* webpackMode: "eager", webpackExports: ["Team"] */ "/vercel/path0/web/src/app/(site)/about/team/components/team/team.tsx");
